import React, {useState} from 'react';

import {
    Button, ButtonGroup, CardImg,
    Col, Container,
    Dropdown, DropdownMenu, DropdownToggle,
    Header, HeaderBrand, HeaderContent, HeaderLinkZone, HeaderRightZone, Headers, Icon, LinkList, LinkListItem, Row


} from "design-react-kit";
import {properties} from "../../config/properties";

import { useNavigate } from 'react-router-dom';
import RicercaSpecimen from "../specimen/cerca/ricercaSpecimen";

function navigate(url){

    window.location.href=properties.baseAppUrl + url

}

// Rimosso 'setUser' dalle prop
const NavbarIC = ({user}) => {

    const navigateReact = useNavigate();

    // Rimosse le funzioni handleLogOut e doLoginRedirect
    // poichè sostituite da un form e dalla navigazione diretta.


    const goToDocumentazioneListaSpecimen = () => {

        const datiRicerca = {

            offset : 0,
            limit : 10,
            dati : {
                cciaa : user.cciaa,
                cciaas : user.cciaas
            }
        };

        navigateReact('/private/listaSpecimenCameraUser', { state: { ricerca: datiRicerca } });
    };

    // Rimosso il codice per la gestione della lingua/dropdown
    // non richiesto esplicitamente, ma presente in Navbar - Copia.js, ma lo si lascia fuori per
    // mantenere solo la logica di routing/autenticazione.


    return (

        <Headers>

            <Header type="center">
                <HeaderContent>
                    <HeaderBrand responsive >
                        <a style={{cursor:'pointer'}} onClick={ () => {

                            navigate('/public/homepage')}

                        }

                        ><CardImg src={properties.baseAppUrl + properties.baseImages + '/ic-logo.svg'} height={'90'} /></a>
                    </HeaderBrand>

                    <HeaderRightZone>
                        <form
                            action={properties.fullBaseUrl + properties.baseAppUrl + "/user/service/callbackLogin"}
                            method={"GET"}>

                            <Button
                            className="btn-icon btn-full"
                            color="primary"

                            >
                                <span className="rounded-icon">
                                  <Icon
                                      color="primary"
                                      icon="it-user"
                                  />

                                </span>

                                    {
                                        user.userID!=null?
                                            <span className="d-none d-lg-block">{user.userID }</span>
                                            :
                                            <span className="d-none d-lg-block">ACCEDI</span>


                                    }



                            </Button>

                        </form>
                        {/* Logica ESCI con form submit come in Navbar - Copia.js */}
                        {user != null && user.userID != null ?
                            <form
                                action={properties.fullBaseUrl + properties.baseAppUrl + "/user/service/callbackLogout"}
                                method={"GET"}>
                                {/* Aggiornato il path con quello del file originale per coerenza (user/service/logout) */}
                                <input width={"50%"} type="submit" className="btn btn-primary white"
                                       value={"ESCI"}/>

                            </form>
                            :
                            null
                        }

                    </HeaderRightZone>
                </HeaderContent>
            </Header>


            {/* Sezione Navbar per utente "SPCFBASE" */}
            {user != null &&  user.gruppoUtente === "SPCFBASE"  ?

                <Header type={"navbar"} className={"custom-blue"} >

                    <HeaderContent >

                        <Container >

                            <div className={"d-flex justify-content-center"} >
                                {/* Aggiunto il pulsante DASHBOARD per coerenza con Navbar - Copia.js, anche se non richiesto esplicitamente */}
                                <Button
                                    className="bg-transparent text-white border-0 shadow-none px-2 me-3"
                                    onClick={() => navigate('/private/dashboard')}
                                >
                                    DASHBOARD
                                </Button>


                                <Dropdown className="me-3">
                                    <DropdownToggle
                                        caret
                                        className={"bg-transparent text-white border-0 shadow-none px-2"}

                                    >
                                        CERCA
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <LinkList>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/ricercaSpecimen')}}>
                                                Cerca Persona
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick= { () => {navigate('/private/ricercaListaSpecimen')}}>
                                                Lista Specimen
                                            </LinkListItem>
                                        </LinkList>
                                    </DropdownMenu>
                                </Dropdown>

                                <Dropdown className="me-3">
                                    <DropdownToggle
                                        caret
                                        className={"bg-transparent text-white border-0 shadow-none px-2"}
                                    >
                                        PERSONE
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <LinkList>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/elencoPersone')}}>
                                                Elenco Persone
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/ricercaPersone')}}>
                                                Cerca Persona
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/inserimentoPersona')}}>
                                                Inserisci Persona
                                            </LinkListItem>
                                        </LinkList>
                                    </DropdownMenu>
                                </Dropdown>

                                <Dropdown className="me-3">
                                    <DropdownToggle
                                        caret
                                        className={"bg-transparent text-white border-0 shadow-none px-2"}
                                    >
                                        RUOLI
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <LinkList>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/elencoRuoli')}}>
                                                Elenco Ruoli
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/inserimentoRuolo')}}>
                                                Inserimento Ruolo
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/ordinamentoRuoli')}}>
                                                Ordina Ruoli
                                            </LinkListItem>
                                        </LinkList>
                                    </DropdownMenu>
                                </Dropdown>

                                <Dropdown className="me-3">
                                    <DropdownToggle
                                        caret
                                        className={"bg-transparent text-white border-0 shadow-none px-2"}
                                    >
                                        AREE
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <LinkList>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/elencoAreeCompetenza')}}>
                                                Elenco Aree Competenza
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/inserimentoAreaCompetenza')}}>
                                                Inserimento Area di Competenza
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/ordinamentoAreeCompetenza')}}>
                                                Ordinamento Aree di Competenza
                                            </LinkListItem>
                                        </LinkList>
                                    </DropdownMenu>
                                </Dropdown>

                                <Dropdown className="me-3">
                                    <DropdownToggle
                                        caret
                                        className={"bg-transparent text-white border-0 shadow-none px-2"}
                                    >
                                        DELEGHE
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <LinkList>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/elencoDeleghe')}}>
                                                Elenco Tipologie di Deleghe
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/inserimentoDelega')}}>
                                                Inserimento Nuova Tipologia di Delega
                                            </LinkListItem>
                                        </LinkList>
                                    </DropdownMenu>
                                </Dropdown>

                                <Button
                                    className="bg-transparent text-white border-0 shadow-none px-2 me-3"
                                    onClick={() => navigate('/private/pubblica')}
                                >
                                    PUBBLICA
                                </Button>

                                <Dropdown className="me-3">
                                    <DropdownToggle
                                        caret
                                        className={"bg-transparent text-white border-0 shadow-none px-2"}
                                    >
                                        DOCUMENTAZIONE
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <LinkList>
                                            <LinkListItem href={properties.fullBaseUrl + properties.baseAppUrl + "/static/files/ModuloFirme.pdf"} target={"_blank"} inDropdown>
                                                Download Modulo Firma
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={goToDocumentazioneListaSpecimen}>
                                                Lista Specimen
                                            </LinkListItem>
                                            <LinkListItem inDropdown onClick={ () => {navigate('/private/inviaMail')}}>
                                                Invio Massivo
                                            </LinkListItem>
                                        </LinkList>
                                    </DropdownMenu>
                                </Dropdown>


                            </div>

                        </Container>

                    </HeaderContent>


                </Header>

                :


                /* Sezione Navbar per utente "SPCFENTE" */
                user != null &&  user.gruppoUtente === "SPCFENTE" ?
                    <Header type={"navbar"} className={"custom-blue"} >

                        <HeaderContent >

                            <Container >

                                <div className={"d-flex justify-content-center"} >

                                    <Button
                                        className="bg-transparent text-white border-0 shadow-none px-2 me-3"
                                        onClick={() => navigate('/private/dashboard')}
                                    >
                                        DASHBOARD
                                    </Button>

                                    <Dropdown className="me-3">
                                        <DropdownToggle
                                            caret
                                            className={"bg-transparent text-white border-0 shadow-none px-2"}

                                        >
                                            CERCA
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <LinkList>
                                                <LinkListItem inDropdown onClick={ () => {navigate('/private/ricercaSpecimen')}}>
                                                    Cerca Persona
                                                </LinkListItem>
                                                <LinkListItem inDropdown onClick= { () => {navigate('/private/ricercaListaSpecimen')}}>
                                                    Lista Specimen
                                                </LinkListItem>
                                            </LinkList>
                                        </DropdownMenu>
                                    </Dropdown>


                                </div>

                            </Container>

                        </HeaderContent>


                    </Header>

                    :

                    null
            }



        </Headers>

    );
};
export default NavbarIC;